<template>
    <div id="geostatus_widget">
        <router-view> </router-view>
    </div>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex'
    import GeoStatusKeyInput from './views/GeoStatusKeyInput';
    import GeoStatusMap from './views/GeoStatusMap';


    export default {
        props: ['order'],
        components: { GeoStatusMap, GeoStatusKeyInput },
        computed: {
            ...mapGetters(['visit'])
        },
        methods: {
            ...mapMutations([
                'editVisitKey'])
        },
        mounted() {
            if (this.$props.order) {
                this.editVisitKey(this.$props.order);
                this.$router.push({ name: 'map' });
            }

        }

    }
</script>

<style lang="stylus">

    body, html {
        width: 100%;
        height: 100%;
        background: #283f61;
        font-family: GothamPro !important;
    }

        html body div.fish.top.center.notices div div.fish.notice.success.move-in {
            background-color: floralwhite;
            color: black;
            border-radius: 18px;
        }

        html body div.fish.top.center.notices div div.fish.notice.error.move-in {
            background-color: floralwhite;
            color: black;
            border-radius: 18px;
        }

    #geostatus_widget {
        width: 100%;
        height: 100%;
        background: #283f61;
        padding: 0px;
    }

    #geostatus_link {
        color: aliceblue;
        display: inline-block;
        vertical-align: middle;
        margin-left: 20px;
        margin-top: 5px;
    }

    </style>